import { useLocation, useHistory } from 'react-router-dom';
import { useContext } from 'react';
import { Context } from '@js/routes';

export const usePath = (isEdit: boolean) => {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  const { shouldSkipCompatibility } = useContext(Context);
  const steps = currentPath.includes('/investor_registration') ? [
    { id: 0, stepNum: 0, name: '基本情報', path: '/investor_registration' },
    { id: 1, stepNum: 1, name: '投資適合性', path: '/investor_registration/compatibility' },
    { id: 2, stepNum: 2, name: '本人確認書類', path: '/investor_registration/identification' },
    { id: 3, stepNum: 3, name: '口座情報', path: '/investor_registration/bank_account' },
    { id: 4, stepNum: 4, name: '入力内容', path: '/investor_registration/confirmation' }
  ]
    : [
      { id: 0, stepNum: 0, name: '基本情報', path: '/corporate_registration' },
      { id: 1, stepNum: 1, name: '担当者の情報', path: '/corporate_registration/representative' },
      { id: 2, stepNum: 2, name: '実質的支配者', path: '/corporate_registration/owner' },
      { id: 3, stepNum: 3, name: '投資適合性', path: '/corporate_registration/compatibility' },
      { id: 4, stepNum: 4, name: '口座情報', path: '/corporate_registration/bank_account' },
      { id: 5, stepNum: 5, name: '本人確認方法の選択', path: '/corporate_registration/identity_verification_type' },
      { id: 6, stepNum: 5, name: '本人確認情報', path: '/corporate_registration/identification' },
      { id: 7, stepNum: 6, name: '入力内容', path: '/corporate_registration/confirmation' }
    ];

  const stepLength = steps.length;
  const currentStep = [...steps].reverse().find(step => currentPath.includes(step.path)) || steps[0];

  // 投資適合性スキップを考慮したprev/nextステップの計算
  const isCorporateRegistration = currentPath.includes('/corporate_registration');
  const ownerStepId = 2;  // 実質的支配者
  const compatibilityStepId = 3;  // 投資適合性
  const bankAccountStepId = 4;  // 口座情報

  let prevStep = steps[currentStep.id - 1] || steps[0];
  let nextStep = steps[currentStep.id + 1] || steps[steps.length - 1];

  // 法人登録で投資適合性がスキップされる場合の特別処理
  if (isCorporateRegistration && shouldSkipCompatibility) {
    // オーナーページ（id: 2）から次に進む場合、投資適合性（id: 3）をスキップして口座情報（id: 4）へ
    if (currentStep.id === ownerStepId) {
      nextStep = steps[bankAccountStepId];
    }
    // 口座情報ページ（id: 4）から戻る場合、投資適合性（id: 3）をスキップしてオーナー（id: 2）へ
    if (currentStep.id === bankAccountStepId && prevStep.id === compatibilityStepId) {
      prevStep = steps[ownerStepId];
    }
  }

  const confirmPath = steps[steps.length - 1].path;
  const isFirstStep = currentStep.id === 0;
  const isLastStep = currentStep.id === stepLength - 2;
  const isConfirmStep = currentStep.id === stepLength - 1;
  const identificationStep = steps.filter(step => step.path === '/corporate_registration/identity_verification_type')[0];
  const isFromConfirmation = new URLSearchParams(location.search).get('from') === 'confirmation';

  const pushNext = () => {
    // confirmation画面から来た場合は、confirmation画面に戻る
    if (isFromConfirmation) {
      window.location.href = confirmPath;
      return;
    }

    // 既存の処理
    if (isEdit) {
      if (currentStep.id < 2) {
        // 基本情報または担当者情報変更後の本人確認画面へのパラメータ付き遷移
        let redirectPath = identificationStep.path;

        if (currentStep.id === 0) {
          // 基本情報変更からの遷移
          redirectPath += '?from=basic_info';
        } else if (currentStep.id === 1) {
          // 担当者情報変更からの遷移
          redirectPath += '?from=representative';
        }

        history.push(redirectPath);
      } else if (currentStep.id === identificationStep.id) {
        history.push(nextStep.path);
      } else {
        window.location.href = '/mypage/account';
      }
    } else {
      if (isLastStep) {
        window.location.href = confirmPath;
      } else {
        history.push(nextStep.path);
      }
    }
  };

  return {
    steps,
    stepLength,
    prevStep,
    currentStep,
    nextStep,
    isFirstStep,
    isLastStep,
    isConfirmStep,
    pushNext
  };
};
